import { gql } from '@apollo/client'

/**
 * @typedef {Object} PMListItemGraphQLResponse
 * @property {string} type The content type
 * @property {string} id The content id
 * @property {string} [imageId] The image id (for legacy people lists)
 * @property {string} [imageUrl] The image URL (computed)
 * @property {string} [title] The content title (computed)
 * @property {string} [childListId] The child list id
 */

/**
 * @typedef {Object} PMListGraphQLResponse
 * @property {string} id The primary identifier for this record
 * @property {string} type List type string constant that determines what kind of
 *   content the list contains. Valid types: 'content' (mix of videos and series from
 *   content model), 'content-people' (people/instructors from content model),
 *   'content-tags' (tags from content model), 'portals' (user portals), 'people'
 *   (legacy people list type)
 * @property {string} language Two letter language code (e.g., 'en', 'es', 'fr')
 *   for the list's language
 * @property {string} adminTitle Administrative title used in admin interfaces to
 *   identify this list. Not displayed to end users. Only visible to EDITOR and
 *   SITE_ADMIN roles.
 * @property {string} [title] Title displayed to end users. User-facing title for
 *   the list (e.g., 'Featured Videos', 'Popular Series')
 * @property {string} [description] Description displayed to end users.
 *   User-facing description explaining what the list contains
 * @property {Array<PMListItemGraphQLResponse>} listItems Array of content type/content
 *   id objects that make up this list. Each item specifies a content type
 *   (e.g., 'video', 'series', 'person') and content ID
 * @property {string} createdAt The date the row was created
 * @property {string} updatedAt The date the row was last updated
 */

/**
 * @typedef {Object} PMListListResponseGraphQLResponse
 * @property {Array<PMListGraphQLResponse>} pmLists A list of PM List
 * @property {number} [count] The total number of PM Lists matching the query
 * @property {number} limit The limit used in the query
 * @property {number} offset The offset used in the query
 */

const GET_PM_LIST_QUERY = gql`
  query GetPmList($listId: ID!) {
    pmListList(
      where: { id: { eq: $listId } }
      limit: 1
    ) {
      pmLists {
        id
        type
        language
        adminTitle
        title
        description
        listItems {
          type
          id
          imageId
          imageUrl
          title
          childListId
        }
        createdAt
        updatedAt
      }
    }
  }
`

export default GET_PM_LIST_QUERY
